import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { useTranslation } from '../../i18n';
import styles from './Charts.module.css';

interface Props {
  data: Array<{ month: string; count: number }>;
  title?: string;
}

export function AcquisitionLineChart({ data, title }: Props) {
  const { t } = useTranslation();

  if (data.length === 0) {
    return <div className={styles.empty}>{t('stats.noData')}</div>;
  }

  const labeled = data.map((d) => ({
    ...d,
    label: d.month.slice(2), // "2025-03" -> "25-03"
  }));

  return (
    <div className={styles.chartCard}>
      <h3 className={styles.chartTitle}>{title ?? t('stats.acquisitionTimeline')}</h3>
      <div className={styles.chartWrap}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={labeled} margin={{ top: 8, right: 8, bottom: 8, left: 0 }}>
            <defs>
              <linearGradient id="acqGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="var(--accent)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="var(--accent)" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
            <XAxis
              dataKey="label"
              tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
              axisLine={{ stroke: 'var(--border)' }}
              tickLine={false}
            />
            <YAxis
              allowDecimals={false}
              tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
              axisLine={{ stroke: 'var(--border)' }}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--text-primary)',
                fontSize: '0.75rem',
              }}
            />
            <Area
              type="monotone"
              dataKey="count"
              stroke="var(--accent)"
              fill="url(#acqGradient)"
              strokeWidth={2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
